import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const USPatent = () => {
  const faqs = [
    {
      question:
        "Q: What is 'US Patents' feature ?",
      answer:
        "A: The US Patent feature lets users retrieve bibliographic details for US Patents.",
    },
    {
      question: "Q: How many application numbers can I enter at once ?",
      answer: "A: You can enter up to 500 application numbers per request.",
    },
    {
      question: "Q: Can I extract data for multiple jurisdictions at once ?",
      answer:
        "A: No. You must select one option at a time and enter application numbers for that option only.",
    },
    {
      question: "Q: What happens if I enter an invalid number ?",
      answer:
        "A: JUNE shows an error in the UI and sends an email: “No data found. Check input and try again.",
    },
    {
      question: "Q: How quickly will I get the results ?",
      answer:
        "A: In most cases, results are generated instantly and are available for download from the JUNE interface. For larger requests (up to 500 application numbers), processing may take longer, and you will receive an email notification once the file is ready.",
    },
  ];

  return (
    <Box>
      {faqs.map((faq, i) => (
        <Accordion
          key={i}
          defaultExpanded={i === 0}
          sx={{
            backgroundColor: "#fff",
            "&.Mui-expanded": {
              margin: 0,
            },
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="body2" fontWeight="bold">
              {faq.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {typeof faq.answer === "string" ? (
              <Typography sx={{ whiteSpace: "pre-line" }}>{faq.answer}</Typography>
            ) : (
              faq.answer
            )}
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

const USTrademark = () => {
  const faqs = [
    {
      question:
        "Q: What is 'US Trademark' feature in JUNE ?",
      answer:
        "A: The US Trademark feature lets users retrieve bibliographic details for US Trademark.",
    },
    {
      question: "Q: How many application numbers can I enter at once ?",
      answer: "A: You can enter up to 500 application numbers per request.",
    },
    {
      question: "Q: Can I extract data for multiple jurisdictions at once ?",
      answer:
        "A: No. You must select one option at a time and enter application numbers for that option only.",
    },
    {
      question: "Q: What happens if I enter an invalid number ?",
      answer:
        "A: JUNE shows an error in the UI and sends an email: “No data found. Check input and try again.",
    },
    {
      question: "Q: How quickly will I get the results ?",
      answer:
        "A: In most cases, results are generated instantly and are available for download from the JUNE interface. For larger requests (up to 500 application numbers), processing may take longer, and you will receive an email notification once the file is ready"
    },
  ];

  return (
    <Box>
      {faqs.map((faq, i) => (
        <Accordion
          key={i}
          defaultExpanded={i === 0}
          sx={{
            backgroundColor: "#fff",
            "&.Mui-expanded": {
              margin: 0,
            },
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="body2" fontWeight="bold">
              {faq.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {typeof faq.answer === "string" ? (
              <Typography sx={{ whiteSpace: "pre-line" }}>{faq.answer}</Typography>
            ) : (
              faq.answer
            )}
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

const AUPatent = () => {
  const faqs = [
    {
      question:
        "Q: What is 'AU Patent' feature in JUNE ?",
      answer:
        "A: The AU Patent feature lets users retrieve bibliographic details for Australian Patents.",
    },
    {
      question: "Q: How many application numbers can I enter at once ?",
      answer: "A: You can enter up to 500 application numbers per request.",
    },
    {
      question: "Q: Can I extract data for multiple jurisdictions at once ?",
      answer:
        "A: No. You must select one option at a time and enter application numbers for that option only.",
    },
    {
      question: "Q: What happens if I enter an invalid number ?",
      answer:
        "A: JUNE shows an error in the UI and sends an email: “No data found. Check input and try again.",
    },
    {
      question: "Q: How quickly will I get the results ?",
      answer:
        "A: In most cases, results are generated instantly and are available for download from the JUNE interface. For larger requests (up to 500 application numbers), processing may take longer, and you will receive an email notification once the file is ready",
    },
  ];

  return (
    <Box>
      {faqs.map((faq, i) => (
        <Accordion
          key={i}
          defaultExpanded={i === 0}
          sx={{
            backgroundColor: "#fff",
            "&.Mui-expanded": {
              margin: 0,
            },
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="body2" fontWeight="bold">
              {faq.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {typeof faq.answer === "string" ? (
              <Typography sx={{ whiteSpace: "pre-line" }}>{faq.answer}</Typography>
            ) : (
              faq.answer
            )}
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

const AUTrademark = () => {
  const faqs = [
    {
      question:
        "Q: What is 'AU Trademark' feature ?",
      answer:
        "A: The AU Trademark feature lets users retrieve bibliographic details for Australian trademarks.",
    },
    {
      question: "Q: How many application numbers can I enter at once ?",
      answer: "A: You can enter up to 500 application numbers per request.",
    },
    {
      question: "Q: Can I extract data for multiple jurisdictions at once ?",
      answer:
        "A: No. You must select one option at a time and enter application numbers for that option only.",
    },
    {
      question: "Q: What happens if I enter an invalid number ?",
      answer:
        "A: JUNE shows an error in the UI and sends an email: “No data found. Check input and try again.",
    },
    {
      question: "Q: How quickly will I get the results ?",
      answer:
        "A: In most cases, results are generated instantly and are available for download from the JUNE interface. For larger requests (up to 500 application numbers), processing may take longer, and you will receive an email notification once the file is ready",
    },
  ];

  return (
    <Box>
      {faqs.map((faq, i) => (
        <Accordion
          key={i}
          defaultExpanded={i === 0}
          sx={{
            backgroundColor: "#fff",
            "&.Mui-expanded": {
              margin: 0,
            },
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="body2" fontWeight="bold">
              {faq.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {typeof faq.answer === "string" ? (
              <Typography sx={{ whiteSpace: "pre-line" }}>{faq.answer}</Typography>
            ) : (
              faq.answer
            )}
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export {USPatent, USTrademark, AUPatent, AUTrademark};
